<style scoped>
.card {
  box-shadow: 0 4px 8px 0 rgba(0,0,0,0.2);
  transition: 0.3s;
  width: 100%;
  /* height: 120px; */
  border-radius: 10px;
}
.card-flex {
  box-shadow: 0 4px 8px 0 rgba(0,0,0,0.2);
  transition: 0.3s;
  width: 100%;
  cursor: pointer;
  border-radius: 5px;
  display: flex;
}

.card-active {
    border: 1px solid #e3fd38;
    background:#e3fd38;
    /* background: transparent; */
}

.card-flex:hover {
  box-shadow: 0 8px 16px 0 #e3fd38;
}

.card:hover {
  box-shadow: 0 8px 16px 0 rgba(0,0,0,0.2);
}
.d-none-width {
    width: 250px; 
    max-width: 250px; 
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
}
.d-none-price {
    width: 120px;
}
.bottom-title-left {
    text-align: left;
}
.bottom-title-right {
    text-align: right;
}

.right-side-info {
    text-align: right;
}

.left-side-info {
    text-align: left;
}
.responsive-dialog .el-dialog {
  width: 50%;
}
.mobile{
    padding: 0 40px;
  }
@media only screen and (max-width: 600px) {
  .mobile{
    font-size: 10px;
  }
  .responsive-dialog .el-dialog {
    width: 90%; /* dialog-ийн өргөнийг 90% болгож өөрчлөх */
  }
  .d-none-link {
    max-width: 50%;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }
  .card-phone {
      width: 80%;
  }
  .d-none-width {
    width: auto;
    max-width: 100%;
  }
  .d-none-price {
      width: auto;
  }
  .mobile-product {
      padding: 20px;
  }
  .bottom-title-left {
      text-align: right;
  }
  .bottom-title-right {
      text-align: right;
  }
  .right-side-info {
    text-align: center;
  }

  .left-side-info {
    text-align: center;
  }
}
</style>
<template>
    <div>
        <main id="content" role="main" class="cart-page" v-loading.fullscreen.lock="fullscreenLoading">
            <div class="container mt-5">
                <div class="mb-4" align="left">
                    <h5 class="ml-1">Захиалгын хуудас</h5>
                </div>
                <div class="row">
                    <div class="mb-2 cart-table col-md-8 card" style="overflow: auto;">
                        <div class="p-3" align="center">
                            <div class="mt-2 mb-1"><span class="font-size-18">ЗАХИАЛГЫН ДУГААР</span> <br><span :style="{'font-weight': '700', 'font-size': '16px', 'display': 'block', 'margin-top': '-5px','color':'#027bc4'}" >{{order.invoiceId}}</span></div>
                            <div style="border-bottom:solid 1px"></div>
                            <div>
                                <table class="table" cellspacing="0">
                                    <tbody>
                                        <div v-for="(item, index) in product" :key="index" class="mb-1 card-phone" vAlign="middle">
                                            <tr class="mobile-product" :style="{'padding-bottom': '18px', 'position': 'relative'}">
                                                <td class="d-none d-md-table-cell pr-5">
                                                    <router-link :to="'/single-product/'+item.code"><img class="img-fluid max-width-60 p-1" :src="item.image" :alt="item.name"></router-link>
                                                </td>

                                                <td  class="d-none-width">
                                                    <router-link :to="'/single-product/'+item.code" class="text-gray-90 d-none-link">{{item.name}}<br><strong>{{item.code}}</strong> #{{item.color_name}}</router-link>
                                                </td>

                                                <td  class="d-none-price">
                                                    <div>
                                                        <span >₮{{Number(item.amount).toLocaleString()}}</span>
                                                    </div>
                                                </td>

                                                <td  class="d-none-price" align="center">
                                                    <span>x {{item.quantity}}</span>
                                                </td>

                                                <td  class="d-none-price" align="right">
                                                    <span >₮{{Number(item.amount * item.quantity).toLocaleString()}}</span>
                                                </td>
                                            </tr>
                                        </div>
                                    </tbody>
                                </table>
                            </div>
                            <div class="mt-5 row">
                                <div class="col-md-12 bottom-title-left p-3 pl-5 pr-5" :style="{'border-radius': '10px'}">
                                    <span :style="{'font-size': '15px'}">Захиалгын төлөв</span><br>
                                    <span v-if="order.info.status == 'pending'" class="ikea-family-price" :style="{'font-weight': '700', 'font-size': '17px'}">Төлбөр хүлээгдэж байгаа</span>
                                    <span v-else-if="order.info.status == 'paid'" class="text-green" :style="{'font-weight': '700', 'font-size': '17px' }">Төлбөр төлөгдсөн</span>
                                    <span v-else-if="order.info.status == 'ordered'" class="text-black" :style="{'font-weight': '700', 'font-size': '17px' }">Баталгаажсан</span>
                                    <span v-else-if="order.info.status == 'loaded'" class="text-red" :style="{'font-weight': '700', 'font-size': '17px'}">Бээжин дахь IKEA дэлгүүрээс ачигдсан</span>
                                    <span v-else-if="order.info.status == 'came_in_ereen'" class="text-red" :style="{'font-weight': '700', 'font-size': '17px'}">Эрээнд ирсэн</span>
                                    <span v-else-if="order.info.status == 'came_in_ub'" class="text-success" :style="{'font-weight': '700', 'font-size': '17px'}">Улаанбаатарт ирсэн ялгалт хийгдэж байна</span>
                                    <span v-else-if="order.info.status == 'in_stock'" class="text-success" :style="{'font-weight': '700', 'font-size': '17px'}"> Хэрэглэгчийн хаяг болон түгээлтийн  байршилруу хүргэлт хийгдэж байна</span>
                                    <span v-else-if="order.info.status == 'delivered'" class="text-cyan" :style="{'font-weight': '700', 'font-size': '17px'}">Амжилттай гарт олгогдсон</span>
                                    <span v-else-if="order.info.status == 'expired'" class="text-sale" :style="{'font-weight': '700', 'font-size': '17px'}">Цуцлагдсан</span>
                                </div>
                                <div class="col-md-12 bottom-title-left p-3 pl-5 pr-5" :style="{'border-radius': '10px'}">
                                    <span :style="{'font-size': '15px'}">Үүсгэсэн огноо</span><br>
                                    <span v-if="load == true" :style="{'font-size': '15px'}">{{new Date(order.info.created_at).toISOString().replace(/T/, ' ').replace(/\..+/, '')}}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="mb-8 cart-total col-md-4" align="center">
                        <div class="row card p-5">
                                <div class="col-md-12">
                                    <div class="border-bottom border-color-1 mb-3" align="right">
                                        <h3 class="d-inline-block  mb-0 pb-2 font-size-22">Захиалгын мэдээлэл</h3>
                                    </div>
                                    <table class="table mb-3 mb-md-0">
                                        <tbody>
                                            <tr class="cart-subtotal">
                                                <td class="subtotal-items"> Нэмэгдсэн бонус</td>
                                                <td data-title="Нэмэгдэх бонус"><span class="amount">{{Number(order.info.add_bonus).toLocaleString()}}</span></td>
                                            </tr>
                                            <tr class="cart-subtotal" v-if="order.info.used_bonus>0" style="color:#0057AD;">
                                                <td class="subtotal-items"> Ашигласан бонус</td>
                                                <td data-title="Ашиглах бонус" >{{Number(order.info.used_bonus).toLocaleString()}}</td>
                                            </tr>
                                            <tr class="cart-subtotal" v-if="order.info.discount>0">
                                                <td class="subtotal-items"> Хямдрал</td>
                                                <td data-title="Хямдрал"><span class="amount">₮{{Number(order.info.discount).toLocaleString()}}</span></td>
                                            </tr>
                                            <tr class="cart-subtotal" v-if="order.info.coupon>0" style="color:#0057AD;">
                                                <td class="subtotal-items"> Ваучер</td>
                                                <td data-title="Хөнгөлөлт"><span class="amount">₮{{Number(order.info.coupon).toLocaleString()}}</span></td>
                                            </tr>
                                            <tr class="order-total">
                                                <td class="subtotal-items"> Үйлчилгээний хөлс</td>
                                                <td>₮{{Number(order.info.fee).toLocaleString()}}</td>
                                            </tr>
                                            <tr class="order-total" v-if="order.info.tax>0">
                                                <td class="subtotal-items"> Хүргэлт</td>
                                                <td>₮{{Number(order.info.tax).toLocaleString()}}</td>
                                            </tr>
                                            <tr class="order-total" v-if="order.info.assemble>0">
                                                <td class="subtotal-items">Угсралт</td>
                                                <td>₮{{Number(order.info.assemble).toLocaleString()}}</td>
                                            </tr>
                                            <tr class="order-total" v-if="order.info.mow>0">
                                                <td class="subtotal-items"> Тогтоолт</td>
                                                <td>₮{{Number(order.info.mow).toLocaleString()}}</td>
                                            </tr>
                                            <tr class="order-total" v-if="order.info.chinaDeliver>0">
                                                <td class="subtotal-items">Овор, жингийн нэмэгдэл</td>
                                                <td>₮{{Number(order.info.chinaDeliver).toLocaleString()}}</td>
                                            </tr>
                                            <tr class="order-total" v-if="order.info.lend_fee>0">
                                                <td class="subtotal-items">{{order.info.lend_name}}</td>
                                                <td>₮{{Number(order.info.lend_fee).toLocaleString()}}</td>
                                            </tr>
                                            <tr class="order-total" v-if="order.info.NOAT>0">
                                                 <td class="subtotal-items"> НӨАТ</td>
                                                 <td>₮{{Number(order.info.NOAT).toLocaleString()}}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <div style="border: solid 1px;"></div>
                                    <div style="display: flex;justify-content: space-between;align-items: center ;padding:0 12px;margin-top: 10px;"> 
                                        <b class="total-amount">Нийт дүн</b>
                                       <span class="price font-size-18 font-weight-bold">{{(order.info.total_amount+order.info.lend_fee).toLocaleString()}}</span>
                                     </div>
                                </div>
                            </div>
                        <div class="row pl-1 pr-1">
                            <div class="col-md-12" align="center">
                                <div>
                                    <button v-if="order.info.status == 'pending' && order.info.payment!='KhanLending'" type="button" @click="showQr" class="btn btn-primary-dark-w mt-2" style="width: 100%; border-radius: 12px;"> Төлөх</button>
                                </div>
                                <div>
                                    <button v-if="order.info.status == 'pending' && order.info.payment=='KhanLending'" type="button" @click="showQr" class="btn btn-primary-dark-w mt-2" style="width: 100%; border-radius: 12px;"> Нэхэмжлэхийн дугаар авах</button>
                                </div>
                                <div>
                                    <button v-if="order.info.status == 'pending'" type="button" @click="backRoute" class="btn btn-outline-primary mt-1" style="width: 100%; border-radius: 12px;"> Буцах</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- <div align="center" class="mt-5 text-sale" :style="{'font-size': '15px'}">
                    Төлбөр төлөгдсөн захиалга <strong>ажлын 24 цагийн</strong> дотор хүргэгдэнэ.
                </div> -->
            </div>
        </main>
        <Brands />
        <el-dialog title="" class="responsive-dialog" :visible.sync="dialogTableVisible" :width="dialogWidth"  :modalAppendToBody="false" :center="true">
            <div class="p-2 text-center">                
                <div v-if="this.order.info.payment == 'qpay'" class="mt-1" :style="{'font-size': '15px'}"><span>QR кодыг уншуулна уу.</span></div>
                <div v-if="this.order.info.payment == 'qpay'||this.order.info.payment=='pocket'" class="grid grid-cols-12" align="center">
                    <qrcode-vue :value="order.info.QRCode" :size="180" level="H" style="margin-top: 20px; margin-bottom: 20px; max-width: 100%;"></qrcode-vue>
                </div>
                <div style="display: flex;flex-wrap: wrap;flex:8" v-if="this.order.info.payment == 'qpay'"> 
                    <a :href="'myapp://qpaywallet://'+order.info.qpay_deeplink" > 
                        <img src="https://s3.qpay.mn/p/e9bbdc69-3544-4c2f-aff0-4c292bc094f6/launcher-icon-ios.jpg" style="width: 40px;height: auto;border-radius: 8px;margin: 6px;">
                    </a>
                    <a :href="'khanbank://'+order.info.qpay_deeplink" > 
                        <img src="https://qpay.mn/q/logo/khanbank.png" style="width: 40px;height: auto;border-radius: 8px;margin: 6px;">
                    </a>
                    <a :href="'statebankmongolia://'+order.info.qpay_deeplink" > 
                        <img src="https://qpay.mn/q/logo/state_3.png" style="width: 40px;height: auto;border-radius: 8px;margin: 6px;">
                    </a>
                    <a :href="'xacbank://'+order.info.qpay_deeplink" > 
                        <img src="https://qpay.mn/q/logo/xacbank.png" style="width: 40px;height: auto;border-radius: 8px;margin: 6px;">
                    </a>
                    <a :href="'tdbbank://'+order.info.qpay_deeplink" > 
                        <img src="https://qpay.mn/q/logo/tdbbank.png" style="width: 40px;height: auto;border-radius: 8px;margin: 6px;">
                    </a>
                    <a :href="'socialpay-payment://'+order.info.qpay_deeplink" > 
                        <img src="https://qpay.mn/q/logo/socialpay.png" style="width: 40px;height: auto;border-radius: 8px;margin: 6px;">
                    </a>
                    <a :href="'most://'+order.info.qpay_deeplink" > 
                        <img src="https://qpay.mn/q/logo/most.png" style="width: 40px;height: auto;border-radius: 8px;margin: 6px;">
                    </a>
                    <a :href="'nibank://'+order.info.qpay_deeplink" > 
                        <img src="https://qpay.mn/q/logo/nibank.jpeg" style="width: 40px;height: auto;border-radius: 8px;margin: 6px;">
                    </a>
                    <a :href="'ckbank://'+order.info.qpay_deeplink" > 
                        <img src="https://qpay.mn/q/logo/ckbank.png" style="width: 40px;height: auto;border-radius: 8px;margin: 6px;">
                    </a>
                    <a :href="'capitronbank://'+order.info.qpay_deeplink" > 
                        <img src="https://qpay.mn/q/logo/capitronbank.png" style="width: 40px;height: auto;border-radius: 8px;margin: 6px;">
                    </a>
                    <a :href="'bogdbank://'+order.info.qpay_deeplink" > 
                        <img src="https://qpay.mn/q/logo/bogdbank.png" style="width: 40px;height: auto;border-radius: 8px;margin: 6px;">
                    </a>
                    <a :href="'transbank://q'+order.info.qpay_deeplink" > 
                        <img src="https://qpay.mn/q/logo/transbank.png" style="width: 40px;height: auto;border-radius: 8px;margin: 6px;">
                    </a>
                    <a :href="'mbank://'+order.info.qpay_deeplink" > 
                        <img src="https://qpay.mn/q/logo/mbank.png" style="width: 40px;height: auto;border-radius: 8px;margin: 6px;">
                    </a>
                    <a :href="'ard://'+order.info.qpay_deeplink" > 
                        <img src="https://qpay.mn/q/logo/ardapp.png" style="width: 40px;height: auto;border-radius: 8px;margin: 6px;">
                    </a>
                    <a :href="'toki://'+order.info.qpay_deeplink" > 
                        <img src="https://qpay.mn/q/logo/toki.png" style="width: 40px;height: auto;border-radius: 8px;margin: 6px;">
                    </a>
                    <a :href="'arig://'+order.info.qpay_deeplink" > 
                        <img src="https://qpay.mn/q/logo/arig.png" style="width: 40px;height: auto;border-radius: 8px;margin: 6px;">
                    </a>
                    <a :href="'Monpay://'+order.info.qpay_deeplink" > 
                        <img src="https://qpay.mn/q/logo/monpay.png" style="width: 40px;height: auto;border-radius: 8px;margin: 6px;">
                    </a>

                </div>
                <div v-if="order.info.payment=='mcredit'"><img :src="order.info.QRCode"></div>
                <div>
                <!-- <div v-if="this.order.info.payment == 'qpay'" align="center" :style="{'font-size': '18px'}">Шилжүүлгийн мэдээлэл</div> -->
                <div class="mobile" align="center" v-if="this.order.info.payment == 'mobile'">
                    <span class="font-size-16 mb-4">Шилжүүлгийн мэдээлэл</span>            
                    <div class="row mt-4" align="left">
                        <div class="col-6 ">Хүлээн авагчийн нэр</div>
                        <div class="col-6">Ай Си Би Си ХХК</div>
                        <div class="col-6 ">Банкны нэр</div>
                        <div class="col-6">Голомт банк</div>
                        <div class="col-6 ">Дансны дугаар</div>
                        <div class="col-6 font-weight-bold"><span>141 000 2791</span></div>
                        <div class="col-6 ">Гүйлгээний утга</div>
                        <div class="col-6 mb-2">{{String(order.info.ordernumber).substr(0,2)}}{{ String(order.info.ordernumber).substr(-4)}}</div>
                        <div  class="col-12" style="padding: 0 14px;"><div style="border-bottom:solid 1px;width: 100%;"></div> </div>
                        <div class="col-6 "></div>
                        <div class="col-6 font-size-16 font-weight-bold"><span>₮{{(order.info.total_amount+order.info.lend_fee).toLocaleString()}}</span></div>
                        <div class="col-12 mt-2" align="center"> 
                           <span class="ikea-family-price font-size-12" style="word-break: keep-all;">Шилжүүлэг хийгдсэнээс хойш ажлын 4 цагийн дотор таны захиалга баталгаажиж таны бүртгэлтэй утасруу мэдэгдэл очих болно.</span>
                           <br><span class="mt-2 ikea-family-price font-size-12" style="display: block;">Биднийг сонгосонд баярлалаа.</span><br>
                           <span class="ikea-family-price"><img src="@/assets/images/login/call.png" style="width: 15px;margin-top: -2px;margin-right: 2px;"> 7511-4532</span>
                        </div>
                    </div>
                </div>
                <div class="mobile" align="center" v-if="this.order.info.payment == 'KhanLending'">
                    <span class="font-size-18 mb-4" style="word-break: keep-all">Хүсэлт амжилттай илгээгдлээ !</span> 
                    <div class="mt-4"><span>Захиалгын нийт дүн: </span><span class="ikea-family-price font-weight-bold"> ₮{{(order.info.total_amount+order.info.lend_fee).toLocaleString()}}</span> </div>           
                    <div class="mb-4" style="word-break: keep-all;"><span>Зээлийн хүсэлт илгээснээс хойш ажлын 3 цагийн дотор таны бүртгэлтэй утасруу нэхэмжлэхийн дугаар илгээх болно.</span> </div>
                    <div> 
                        <span style="display: block;">Биднийг сонгосонд баярлалаа.</span>
                        <span ><img src="@/assets/images/login/call.png" style="width: 15px;margin-top: -2px;margin-right: 2px;"> 7511-4532</span>
                    </div>
                </div>

                <div v-if="this.order.info.payment == 'mongolchat'" class="mt-5">Хэрэглэгч та <span :style="{'font-weight': '700'}">Mongol Chat</span> аппликэйшны <br> <strong>дуран</strong> хэсэгт дээрх QR кодыг уншуулж төлбөрөө төлнө үү.</div>
                <div v-if="this.order.info.payment == 'mcredit'" class="mt-5">Хэрэглэгч та <span :style="{'font-weight': '700'}">Mcredit</span> аппликэйшнаар <br> дээрх QR кодыг уншуулж төлбөрөө төлнө үү.</div>
                <div v-if="this.order.info.payment == 'pocket'" class="mt-5">Хэрэглэгч та <span :style="{'font-weight': '700'}">Pocket</span> аппликэйшнаар <br> дээрх QR кодыг уншуулж төлбөрөө төлнө үү.</div>
                <div v-if="this.order.info.payment == 'storepay'" class="mt-5">Хэрэглэгч таны <span :style="{'font-weight': '700'}">Storepay</span> аппликэйшнд <br> <strong>Зээлын хүсэлт</strong> илгээлээ.</div>
                <!-- <div v-if="this.order.info.payment == 'mcredit'" class="mt-5">Хэрэглэгч таны <span :style="{'font-weight': '700'}">M-credit</span> аппликэйшнд <br> <strong>Зээлын хүсэлт</strong> илгээлээ.</div> -->
                </div>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import QrcodeVue from 'qrcode.vue';
import Brands from "@/components/brands";
let checker = null;
export default {
    components: {
        Brands,
        QrcodeVue
    },
    data() {
        return {
            checked:true,
            dialogTableVisible: false,
            fullscreenLoading: false,
            load: false,
            order: {
                invoiceId: '',
                info: [],
                qr: 'https://example.com'
            },
            product: [],
            coupon: 0
        }
    },
    beforeRouteLeave (to, from , next) {
        clearInterval(checker);
        next();
    },
    mounted() {
        window.addEventListener("resize", this.updateDialogWidth);
        this.$emit('getJquery');
        this.order.invoiceId = this.$route.params.invoiceId; 
        this.getInfo();
    },
    computed:{
        dialogWidth() {
      if (window.innerWidth <= 480) {
        return "95%";
      } else if (window.innerWidth <= 768) {
        return "80%";
      } else {
        return "40%";
      }
    },
    },
    beforeDestroy() {
    window.removeEventListener("resize", this.updateDialogWidth);
    },
    methods: {
        orderChecker() {
            const token = localStorage.getItem('token');
            let rts = this;
            this.$axios({
                method: 'post',
                url: this.$appUrl +'/api/purchase/is-paid-qpay',
                headers: {
                    'Authorization': `Bearer ${token}`
                },
                data: {
                    invoiceId: this.order.invoiceId,
                }
            }).then(data => {
                if(data.data.result == 'success') {
                    rts.order.info.status = 'paid';
                    clearInterval(checker);
                    rts.dialogTableVisible = false;
                    rts.$notify({
                        title: 'Амжилттай',
                        message: `Төлбөр амжилттай төлөгдлөө.Танд ${data.data.bonus} нэмэгдлээ.`,
                        type: 'success',
                        duration: 0
                    });
                }
            });
        },
        backRoute(){
            this.$router.push('/confirm-order/'+this.order.invoiceId);
        },
        showQr() {
            this.dialogTableVisible = true;
        },
        getInfo() {
            const token = localStorage.getItem('token');
            var rts = this;
            rts.$axios({
                method: 'POST',
                url: rts.$appUrl + '/api/product/show-order',
                headers: {
                    "Authorization": `Bearer ${token}`
                },
                data: {
                    ordernumber: this.order.invoiceId
                }
            }).then(data => {
                if(data.data.result == 'failed') {
                    rts.$router.push('/error-page');
                } else {
                    // console.log(data.data);
                    rts.product = data.data.product;
                    rts.order.info = data.data.order;
                    rts.load = true;
                    if(rts.order.info.status == 'pending') {
                        rts.dialogTableVisible = true;
                        checker = setInterval(rts.orderChecker, 5000);
                    }
                    
                }
            }).catch(err => {
                rts.$router.push('/error-page');
            });
        }   
    }
}
</script>